
export const addTestTableFromAPI = ( testData ) => {
    return {
        type: "ADD_TEST_DATA_FROM_API",
        testData
    }
}

export const editTestTableData = ( testData ) => {
    return {
        type: "EDIT_TEST_DATA",
        testData
    }
}

export const deleteTestTableData = ( test_point_id ) => {
    return {
        type: "DELETE_TEST_DATA",
        test_point_id
    }
}